import { Header, FeaturedContent, Gallery, Footer } from './components';
import './App.css';
import { ImageViewer } from './components/ImageViewer';
import { useState } from 'react';

export const App = () => {
  // TODO: improve this implementation of image viewer
  // ImageViewer should be on the DOM only if required
  const [viewerVisibility, setViewerVisiblity] = useState(false);
  const [imageObj, setImageObj] = useState({});

  const openViewer = (selectedImageObj) => {
    setImageObj({ ...selectedImageObj });
    setViewerVisiblity(true);
    document.body.style.overflow = 'hidden';
  };

  const closeViewer = () => {
    setImageObj({});
    setViewerVisiblity(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className='container'>
      <Header />
      <FeaturedContent />
      <ImageViewer
        showViewer={viewerVisibility}
        imageObject={imageObj}
        closeViewHandler={closeViewer}
      />
      <Gallery openViewHandler={openViewer} />
      <Footer />
    </div>
  );
};
